import axios from 'axios'

const API = {
    profiles: "/profiles",
    person: "/person"
};

const URL_GENERADOR_DNI = "https://api.generadordni.es/v2";


const GENDNI_AXIOS = axios.create({
    baseURL: URL_GENERADOR_DNI
});

const buildUrl = (endpoint) => {
    return `${URL_GENERADOR_DNI}${endpoint}`;
}


export default class GeneradorDNI {

    radomUser() {
        return GENDNI_AXIOS.get(buildUrl(API.profiles+API.person));
    }

}
